/* empty css          */
import { useLayoutEffect, useRef, useState } from "react";
import { Button, Icon } from "@therms/atalaya";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/components/ShowHideMoreMask/index.tsx
function ShowHideMoreMask({ children, hideMoreHeight = 200 }) {
	const containerRef = useRef(null);
	const [isOverflowingVertically, setIsOverflowingVertically] = useState(!!containerRef.current && containerRef.current.scrollHeight > containerRef.current.clientHeight);
	const [showMore, setShowMore] = useState(false);
	useLayoutEffect(() => {
		setIsOverflowingVertically(!!(containerRef?.current && containerRef.current.scrollHeight > containerRef.current.clientHeight));
	}, [containerRef.current, children]);
	return /* @__PURE__ */ jsxs("div", {
		className: isOverflowingVertically ? "relative" : "",
		onClickCapture: () => isOverflowingVertically ? setShowMore(true) : void 0,
		children: [/* @__PURE__ */ jsxs("div", {
			className: classnames({
				"bottom-masked-container": !showMore && isOverflowingVertically,
				"overflow-hidden": !showMore
			}),
			ref: containerRef,
			style: !showMore ? { maxHeight: `${hideMoreHeight}px` } : {},
			children: [children, showMore && /* @__PURE__ */ jsx("div", {
				className: "w-full text-end",
				children: /* @__PURE__ */ jsxs(Button, {
					onClick: () => setShowMore(false),
					subtle: true,
					variant: "main",
					size: "sm",
					children: [/* @__PURE__ */ jsx(Icon, {
						className: "mr-xs",
						Icon: IoMdArrowDropup
					}), " Show Less"]
				})
			})]
		}), isOverflowingVertically && !showMore && /* @__PURE__ */ jsx("div", {
			className: "absolute bottom-0 right-0",
			children: /* @__PURE__ */ jsxs(Button, {
				onClick: () => setShowMore(true),
				subtle: true,
				variant: "main",
				size: "sm",
				children: [/* @__PURE__ */ jsx(Icon, {
					className: "mr-xs",
					Icon: IoMdArrowDropdown
				}), " Show More"]
			})
		})]
	});
}
//#endregion
export { ShowHideMoreMask };

//# sourceMappingURL=index.js.map